import axios from "axios";

const API_BASE = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/+$/, "");

export async function obtenerReporteFacturas({ fechaInicial, fechaFinal, moneda, empresaId, cliente }) {
  const params = { fechaInicial, fechaFinal, moneda, empresaId };
  if (cliente && cliente.trim()) params.cliente = cliente.trim();
  const { data } = await axios.get(`${API_BASE}/api/reportes/facturas`, { params });
  return data;
}

export async function obtenerReportePagos({ fechaInicial, fechaFinal, moneda, empresaId }) {
  const { data } = await axios.get(`${API_BASE}/api/reportes/pagos`, {
    params: { fechaInicial, fechaFinal, moneda, empresaId },
  });
  return data;
}
